import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, FormControlLabel, Grid, Radio, RadioGroup, TextField } from '@material-ui/core';
import { dateUtcToS } from '../../../util/dateUtil';

const styles = makeStyles((theme) => ({
  sectionSpacer: {
    height: 50,
    padding: '10px 0',
  },
  rowSpacer: {
    height: 30,
  },
  printedContent: {
    '@media print': {
      marginBottom: 10,
    },
    '@media screen': {
      display: 'none',
    },
  },
  unprintedContent: {
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  alignPrintedContent: {
    lineHeight: '25px',
    verticalAlign: 'top',
  },
  radioGroupSpacing: {
    marginTop: 0,
    marginBottom: 15,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
    },
  },
  radioLabel: {
    marginTop: 0,
    marginBottom: 0,
  },
}));

const GeneralInformationV2 = (props) => {
  const { senior, form, setForm, disabled } = props;
  const classes = styles();

  return (
    <Box sx={{ width: '95%' }}>
      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>Name</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          {senior.first_name} {senior.last_name}
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>Birth date</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          {dateUtcToS(senior.dob)}
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>Date of Admission</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          {dateUtcToS(senior.admission_date)}
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>Community</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          {senior.community}
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>Family Teachers</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          {senior.family_teaching_couple}
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>Consultant</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          {senior.consultant}
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>GPA</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          {senior.gpa || ''}
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>ASVAB Score</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          {senior.asvab || ''}
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>ACT Score</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          {senior.act || ''}
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>ACT Preparation participation</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={`${classes.rowSpacer} ${classes.radioGroupSpacing}`}>
          <RadioGroup
            row
            name="actPrep"
            value={form.actPrep ? 'yes' : 'no'}
            onChange={(e) => setForm({ ...form, actPrep: e.target.value === 'yes' })}
            disabled={disabled}
          >
            <FormControlLabel value="yes" control={<Radio color="default" disabled={disabled} />} label="Yes" className={classes.radioLabel} />
            <FormControlLabel value="no" control={<Radio color="default" disabled={disabled} />} label="No" className={classes.radioLabel} />
          </RadioGroup>
        </Grid>
        <Grid item xs={1} md={true} lg={true} className={classes.rowSpacer} />
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>Certification training (OSHA, Forklift, etc)</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          <TextField
            value={form.certTraining || ''}
            onChange={(e) => setForm({ ...form, certTraining: e.target.value })}
            size="small"
            variant="outlined"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>Trades classes taken</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          <TextField
            value={form.tradesClasses || ''}
            onChange={(e) => setForm({ ...form, tradesClasses: e.target.value })}
            size="small"
            variant="outlined"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} className={classes.rowSpacer} />
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>Millard North classes</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          <TextField
            value={form.millardNorth || ''}
            onChange={(e) => setForm({ ...form, millardNorth: e.target.value })}
            size="small"
            variant="outlined"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={1} md={true} lg={true} className={classes.rowSpacer} />
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>Metro Dual Certification(s)</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          <TextField
            value={form.metroDual || ''}
            onChange={(e) => setForm({ ...form, metroDual: e.target.value })}
            size="small"
            variant="outlined"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} className={classes.rowSpacer} />
        <Grid item xs={12} sm={2} md={2} lg={2} className={classes.rowSpacer}>
          <label>Work-based Learning</label>
        </Grid>
        <Grid item xs={1} md={false} lg={false} className={classes.rowSpacer} />
        <Grid item xs={11} sm={3} md={3} lg={3} className={classes.rowSpacer}>
          <TextField
            value={form.workBasedLearning || ''}
            onChange={(e) => setForm({ ...form, workBasedLearning: e.target.value })}
            size="small"
            variant="outlined"
            disabled={disabled}
          />
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={3}>
          <label>Name</label>
        </Grid>
        <Grid item xs={3}>
          {senior.first_name} {senior.last_name}
        </Grid>
        <Grid item xs={3}>
          <label>Community</label>
        </Grid>
        <Grid item xs={3}>
          {senior.community}
        </Grid>
        <Grid item xs={3}>
          <label>Birth Date</label>
        </Grid>
        <Grid item xs={3}>
          {dateUtcToS(senior.dob)}
        </Grid>
        <Grid item xs={3}>
          <label>Family Teachers</label>
        </Grid>
        <Grid item xs={3}>
          {senior.family_teaching_couple}
        </Grid>
        <Grid item xs={3}>
          <label>Date of Admission</label>
        </Grid>
        <Grid item xs={3}>
          {dateUtcToS(senior.admission_date)}
        </Grid>
        <Grid item xs={3}>
          <label>Consultant</label>
        </Grid>
        <Grid item xs={3}>
          {senior.consultant}
        </Grid>
        <Grid item xs={3}>
          <label>GPA</label>
        </Grid>
        <Grid item xs={3}>
          {senior.gpa || 'N/A'}
        </Grid>
        <Grid item xs={3}>
          <label>ASVAB Score</label>
        </Grid>
        <Grid item xs={3}>
          {senior.asvab || 'N/A'}
        </Grid>
        <Grid item xs={3}>
          <label>ACT Score</label>
        </Grid>
        <Grid item xs={3}>
          {senior.act || 'N/A'}
        </Grid>
        <Grid item xs={3}>
          <label>ACT Preparation participation</label>
        </Grid>
        <Grid item xs={3}>
          {form.actPrep ? 'Yes' : 'No'}
        </Grid>
        <Grid item xs={3}>
          <label>Certification training (OSHA, Forklift, etc)</label>
        </Grid>
        <Grid item xs={3}>
          {form.certTraining || 'N/A'}
        </Grid>
        <Grid item xs={3}>
          <label>Millard North classes</label>
        </Grid>
        <Grid item xs={3}>
          {form.millardNorth || 'N/A'}
        </Grid>
        <Grid item xs={3}>
          <label>Metro Dual Certification(s)</label>
        </Grid>
        <Grid item xs={3}>
          {form.metroDual || 'N/A'}
        </Grid>
        <Grid item xs={3}>
          <label>Work-based Learning</label>
        </Grid>
        <Grid item xs={3}>
          {form.workBasedLearning || 'N/A'}
        </Grid>
        <Grid item xs={3}>
          <label>Trades classes taken</label>
        </Grid>
        <Grid item xs={3}>
          {form.tradesClasses || 'N/A'}
        </Grid>
      </Grid>
    </Box>
  );
};

GeneralInformationV2.propTypes = {
  senior: PropTypes.object.isRequired,
  version: PropTypes.number,
  form: PropTypes.object,
  setForm: PropTypes.func,
  disabled: PropTypes.bool,
};

export default GeneralInformationV2;
